<div>
@if(showLogin && !showForgotPwd && !changePwd){
<div class="orgApp-login-wrpr">
  <div mat-dialog-title class="orgApp-text-center orgApp-login-card-title">
    <svg
      width="120"
      height="31"
      viewBox="0 0 120 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.4091 12.3636C22.4091 14.9015 21.928 17.0606 20.9659 18.8409C20.0114 20.6212 18.7083 21.9811 17.0568 22.9205C15.4129 23.8523 13.5644 24.3182 11.5114 24.3182C9.44318 24.3182 7.58712 23.8485 5.94318 22.9091C4.29924 21.9697 3 20.6098 2.04545 18.8295C1.09091 17.0492 0.613636 14.8939 0.613636 12.3636C0.613636 9.82576 1.09091 7.66667 2.04545 5.88636C3 4.10606 4.29924 2.75 5.94318 1.81818C7.58712 0.878787 9.44318 0.40909 11.5114 0.40909C13.5644 0.40909 15.4129 0.878787 17.0568 1.81818C18.7083 2.75 20.0114 4.10606 20.9659 5.88636C21.928 7.66667 22.4091 9.82576 22.4091 12.3636ZM17.4205 12.3636C17.4205 10.7197 17.1742 9.33333 16.6818 8.20455C16.197 7.07576 15.5114 6.2197 14.625 5.63636C13.7386 5.05303 12.7008 4.76136 11.5114 4.76136C10.322 4.76136 9.28409 5.05303 8.39773 5.63636C7.51136 6.2197 6.82197 7.07576 6.32955 8.20455C5.8447 9.33333 5.60227 10.7197 5.60227 12.3636C5.60227 14.0076 5.8447 15.3939 6.32955 16.5227C6.82197 17.6515 7.51136 18.5076 8.39773 19.0909C9.28409 19.6742 10.322 19.9659 11.5114 19.9659C12.7008 19.9659 13.7386 19.6742 14.625 19.0909C15.5114 18.5076 16.197 17.6515 16.6818 16.5227C17.1742 15.3939 17.4205 14.0076 17.4205 12.3636ZM25.9631 24V6.54545H30.6562V9.59091H30.8381C31.1563 8.50758 31.6903 7.68939 32.4403 7.13636C33.1903 6.57576 34.054 6.29545 35.0312 6.29545C35.2737 6.29545 35.535 6.31061 35.8153 6.34091C36.0956 6.37121 36.3419 6.41288 36.554 6.46591V10.7614C36.3267 10.6932 36.0123 10.6326 35.6108 10.5795C35.2093 10.5265 34.8419 10.5 34.5085 10.5C33.7964 10.5 33.16 10.6553 32.5994 10.9659C32.0464 11.2689 31.607 11.6932 31.2812 12.2386C30.9631 12.7841 30.804 13.4129 30.804 14.125V24H25.9631ZM46.108 30.9091C44.5398 30.9091 43.1951 30.6932 42.0739 30.2614C40.9602 29.8371 40.0739 29.2576 39.4148 28.5227C38.7557 27.7879 38.3277 26.9621 38.1307 26.0455L42.608 25.4432C42.7443 25.7917 42.9602 26.1174 43.2557 26.4205C43.5511 26.7235 43.9413 26.9659 44.4261 27.1477C44.9186 27.3371 45.517 27.4318 46.2216 27.4318C47.2746 27.4318 48.142 27.1742 48.8239 26.6591C49.5133 26.1515 49.858 25.2992 49.858 24.1023V20.9091H49.6534C49.4413 21.3939 49.1231 21.8523 48.6989 22.2841C48.2746 22.7159 47.7292 23.0682 47.0625 23.3409C46.3958 23.6136 45.6004 23.75 44.6761 23.75C43.3655 23.75 42.1723 23.447 41.0966 22.8409C40.0284 22.2273 39.1761 21.2917 38.5398 20.0341C37.911 18.7689 37.5966 17.1705 37.5966 15.2386C37.5966 13.2614 37.9186 11.6098 38.5625 10.2841C39.2064 8.95833 40.0625 7.96591 41.1307 7.30682C42.2064 6.64773 43.3845 6.31818 44.6648 6.31818C45.642 6.31818 46.4602 6.48485 47.1193 6.81818C47.7784 7.14394 48.3087 7.55303 48.7102 8.04545C49.1193 8.5303 49.4337 9.00758 49.6534 9.47727H49.8352V6.54545H54.642V24.1705C54.642 25.6553 54.2784 26.8977 53.5511 27.8977C52.8239 28.8977 51.8163 29.6477 50.5284 30.1477C49.2481 30.6553 47.7746 30.9091 46.108 30.9091ZM46.2102 20.1136C46.9905 20.1136 47.6496 19.9205 48.1875 19.5341C48.733 19.1402 49.1496 18.5795 49.4375 17.8523C49.733 17.1174 49.8807 16.2386 49.8807 15.2159C49.8807 14.1932 49.7367 13.3068 49.4489 12.5568C49.161 11.7992 48.7443 11.2121 48.1989 10.7955C47.6534 10.3788 46.9905 10.1705 46.2102 10.1705C45.4148 10.1705 44.7443 10.3864 44.1989 10.8182C43.6534 11.2424 43.2405 11.8333 42.9602 12.5909C42.6799 13.3485 42.5398 14.2235 42.5398 15.2159C42.5398 16.2235 42.6799 17.0947 42.9602 17.8295C43.2481 18.5568 43.661 19.1212 44.1989 19.5227C44.7443 19.9167 45.4148 20.1136 46.2102 20.1136ZM62.5966 24H57.3239L65.358 0.727272H71.6989L79.7216 24H74.4489L68.6193 6.04545H68.4375L62.5966 24ZM62.267 14.8523H74.7216V18.6932H62.267V14.8523ZM82.4318 30.5455V6.54545H87.2045V9.47727H87.4205C87.6326 9.00758 87.9394 8.5303 88.3409 8.04545C88.75 7.55303 89.2803 7.14394 89.9318 6.81818C90.5909 6.48485 91.4091 6.31818 92.3864 6.31818C93.6591 6.31818 94.8333 6.65152 95.9091 7.31818C96.9848 7.97727 97.8447 8.97348 98.4886 10.3068C99.1326 11.6326 99.4545 13.2955 99.4545 15.2955C99.4545 17.2424 99.1402 18.8864 98.5114 20.2273C97.8902 21.5606 97.0417 22.572 95.9659 23.2614C94.8977 23.9432 93.7008 24.2841 92.375 24.2841C91.4356 24.2841 90.6364 24.1288 89.9773 23.8182C89.3258 23.5076 88.7917 23.1174 88.375 22.6477C87.9583 22.1705 87.6402 21.6894 87.4205 21.2045H87.2727V30.5455H82.4318ZM87.1705 15.2727C87.1705 16.3106 87.3144 17.2159 87.6023 17.9886C87.8902 18.7614 88.3068 19.3636 88.8523 19.7955C89.3977 20.2197 90.0606 20.4318 90.8409 20.4318C91.6288 20.4318 92.2955 20.2159 92.8409 19.7841C93.3864 19.3447 93.7992 18.7386 94.0795 17.9659C94.3674 17.1856 94.5114 16.2879 94.5114 15.2727C94.5114 14.2652 94.3712 13.3788 94.0909 12.6136C93.8106 11.8485 93.3977 11.25 92.8523 10.8182C92.3068 10.3864 91.6364 10.1705 90.8409 10.1705C90.053 10.1705 89.3864 10.3788 88.8409 10.7955C88.303 11.2121 87.8902 11.803 87.6023 12.5682C87.3144 13.3333 87.1705 14.2348 87.1705 15.2727ZM102.682 30.5455V6.54545H107.455V9.47727H107.67C107.883 9.00758 108.189 8.5303 108.591 8.04545C109 7.55303 109.53 7.14394 110.182 6.81818C110.841 6.48485 111.659 6.31818 112.636 6.31818C113.909 6.31818 115.083 6.65152 116.159 7.31818C117.235 7.97727 118.095 8.97348 118.739 10.3068C119.383 11.6326 119.705 13.2955 119.705 15.2955C119.705 17.2424 119.39 18.8864 118.761 20.2273C118.14 21.5606 117.292 22.572 116.216 23.2614C115.148 23.9432 113.951 24.2841 112.625 24.2841C111.686 24.2841 110.886 24.1288 110.227 23.8182C109.576 23.5076 109.042 23.1174 108.625 22.6477C108.208 22.1705 107.89 21.6894 107.67 21.2045H107.523V30.5455H102.682ZM107.42 15.2727C107.42 16.3106 107.564 17.2159 107.852 17.9886C108.14 18.7614 108.557 19.3636 109.102 19.7955C109.648 20.2197 110.311 20.4318 111.091 20.4318C111.879 20.4318 112.545 20.2159 113.091 19.7841C113.636 19.3447 114.049 18.7386 114.33 17.9659C114.617 17.1856 114.761 16.2879 114.761 15.2727C114.761 14.2652 114.621 13.3788 114.341 12.6136C114.061 11.8485 113.648 11.25 113.102 10.8182C112.557 10.3864 111.886 10.1705 111.091 10.1705C110.303 10.1705 109.636 10.3788 109.091 10.7955C108.553 11.2121 108.14 11.803 107.852 12.5682C107.564 13.3333 107.42 14.2348 107.42 15.2727Z"
        fill="url(#paint0_linear_2454_54298)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2454_54298"
          x1="60"
          y1="-7"
          x2="115.498"
          y2="-7"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0B69A3" />
          <stop offset="1" stop-color="#40C3F7" />
        </linearGradient>
      </defs>
    </svg>
  </div>
  <mat-dialog-content class="orgApp-login-dlg-cont">
    <form
      [formGroup]="loginForm"
      class="orgApp-d-flex orgApp-flex-dir-col orgApp-gap-24"
      (ngSubmit)="onLoginSubmit()"
    >
      <div class="orgApp-d-flex orgApp-flex-dir-col orgApp-gap-8">
        @if(errorMessage){
        <p class="orgApp-login-att-lmt-error-msg" [innerHTML]="errorMessage"></p>
        }
        <mat-form-field
          hideRequiredMarker="true"
          appearance="fill"
          class="orgApp-login-width orgApp-login-field orgApp-field-rounded-lg orgApp-input-field-md"
          [ngClass]="{
            error:
              loginForm.get('email')?.invalid && loginForm.get('email')?.touched
          }"
        >
          <mat-label class="orgApp-login-form-label">{{
            "login.content.placeholder.username" | translate
          }}</mat-label>
          <input
            matInput
            class="orgApp-login-input"
            placeholder="johndoe@gmail.com"
            formControlName="email"
            inputmode="email"
            (input)="trimSpaces('email')"
            (keydown.enter)="$event.preventDefault(); passwordInput.focus()"
          />
        </mat-form-field>
        @if (loginForm.get('email')?.touched) {
        <ng-container>
          @if (loginForm.get('email')?.errors?.['invalid']) {
          <mat-error
            [ngClass]="{
              'orgApp-login-error-label': loginForm.get('email')?.errors?.['invalid']
            }"
          >
            {{ "login.content.error.username.invalid" | translate }}
          </mat-error>
          }</ng-container
        >}
        <mat-form-field
          hideRequiredMarker="true"
          appearance="fill"
          class="orgApp-login-width orgApp-login-password-field orgApp-login-field orgApp-field-rounded-lg orgApp-input-field-md"
          [ngClass]="{
            error:
             ( loginForm.get('password')?.invalid &&
              loginForm.get('password')?.touched ) || loginForm.get('password')?.hasError('invalidPassword')
          }"
        >
          <mat-label class="orgApp-login-form-label">{{
            "login.content.placeholder.password" | translate
          }}</mat-label>
          <input
            #passwordInput
            matInput
            class="orgApp-login-input"
            [type]="hide ? 'password' : 'text'"
            formControlName="password"
            autocomplete="current-password"
            placeholder="abcd@123"
            (input)="trimSpaces('password')"
            (keydown.enter)="$event.preventDefault(); onLoginSubmit()"
          />
          @if (!passwordIncorrect) {
          <button
            type="button"
            mat-icon-button
            matSuffix
            class="orgApp-login-password-eye"
            (click)="togglePasswordVisibility()"
          >
          <svg width="24" height="24">
            <use [attr.xlink:href]="hide ? '#visibility-login-off' : '#visibility-login-on'"></use>
          </svg>          
            </button
          >}
        </mat-form-field>
        @if (loginForm.get('password')?.touched) {
          <ng-container>
            @if (loginForm.get('password')?.errors?.['maxlength'] &&
            loginForm.get('password')?.touched) {
            <mat-error
              [ngClass]="{
              'orgApp-login-error-label': loginForm.get('password')?.errors?.['maxlength']
            }"
            >
              {{
                "login.content.error.password.maxlength" | translate
              }} </mat-error
            >} 
            @else if((loginForm.get('password')?.touched) && loginForm.get('password')?.hasError('invalidPassword')){
              <mat-error>
                {{ "login.content.error.password.invalid_password" | translate }}
              </mat-error>
            }
          </ng-container>
        }
      </div>

      <div>
        <p
          [ngClass]="{
            'orgApp-login-otp-btn-enable': !disableOtp,
            'orgApp-login-otp-btn-disable': disableOtp
          }"
          class="orgApp-login-otp-btn"
          (click)="requestOtp($event)"
        >
          <b>{{ "login.action.otp_btn" | translate }}</b>
        </p>
      </div>

      <div class="orgApp-d-flex orgApp-flex-dir-col orgApp-gap-32">
        <button
          type="submit"
          mat-raised-button
          class="orgApp-login-action-btn orgApp-sign-in-btn orgApp-login-width"
          [disabled]="loginForm.invalid || disableLogin"
        >
          {{ "login.action.signin_btn" | translate }}
        </button>
        <!-- <div class="orgApp-d-flex orgApp-gap-16 orgApp-align-i-center">
          <hr class="orgApp-login-line" />
          <span class="orgApp-login-span">{{
            "login.action.or" | translate
          }}</span>
          <hr class="orgApp-login-line" />
        </div>
        <button
          mat-stroked-button
          class="orgApp-login-action-btn orgApp-login-width orgApp-sso-btn"
          (click)="ssoLogin()"
        >
          {{ "login.action.sso_btn" | translate }}
        </button> -->
         <div>
        <p
          class="orgApp-login-fgt-pwd-btn orgApp-login-otp-btn-enable"
          (click)="forgotPwd()"
        >
          <b>{{ "login.action.forgot_pwd" | translate }}</b>
        </p>
      </div>
      </div>
    </form>
  </mat-dialog-content>
</div>
}
@else if((!showLogin && !showForgotPwd && !changePwd) || frgtPwdOtp){
  <app-login-otp (updateLoginStatus)="updateLoginStatus($event)" [disableOtp]="disableOtp" (updateOtpAttempt)="updateOtpAttempt($event)" [frgtPwdOtp]="frgtPwdOtp" (closeLogin)="closeLogin($event)"></app-login-otp>
}
@else if(!showLogin && showForgotPwd && !changePwd){
  <app-forgot-password (updateFrgtPwdStatus)="updateFrgtPwdStatus($event)" (closeLogin)="closeLogin($event)"></app-forgot-password>
}
</div>
